import {Container} from '../../../../components/Container';
import React, {KeyboardEvent, memo, useCallback, useEffect, useMemo, useState} from 'react';
import {useRPC} from '../../../../hooks/rpc';
import {useDispatch, useSelector} from 'react-redux';
import {onClickHandler} from '../../../../utils/onclick';
import './index.scss';
import {clearUARTMessagesAction} from '../../../../store/debug/actions';
import {useLocalization} from "../../../../hooks/localization";

export const UartScreen = memo(function UartScreen() {
    const {t} = useLocalization();
    const uartMessageList = useSelector(state => state.debug.uartMessageList);
    const [rpc] = useRPC();
    const dispatch = useDispatch();
    const [message, setMessage] = useState('');
    const [filterMessage, setFilterMessage] = useState('');
    const [versionVisible, setVersionVisible] = useState(true);
    const [onlyRawMessage, setOnlyRawMessage] = useState(false);

    const filteredMessageList = useMemo(() => {
        return uartMessageList.filter(message => {
            if (filterMessage) {
                if (!message.message.includes(filterMessage)) {
                    return false;
                }
            }

            if (versionVisible) {
                return true;
            }

            // noinspection RedundantIfStatementJS
            if (!message.message.includes('version')) {
                return true;
            }

            return false;
        });
    }, [uartMessageList, versionVisible, filterMessage]);

    const send = useCallback(() => {
        if (message) {
            rpc.sendUartMessage(message);
            setMessage('');
        }
    }, [message, rpc]);

    const onKeyPress = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            send();
        }
    }, [send]);

    const hideVersion = useCallback(() => {
        setVersionVisible(v => !v);
    }, []);

    const clear = useCallback(() => {
        dispatch(clearUARTMessagesAction());
    }, [dispatch]);

    const copy = useCallback(() => {
        const text = filteredMessageList.map(m => {
            if (onlyRawMessage) {
                return m.message;
            }

            return `[${m.type[0]}][${m.time}]${m.message}`;
        }).join('\n');

        // noinspection JSIgnoredPromiseFromCall
        navigator.clipboard.writeText(text);
    }, [filteredMessageList, onlyRawMessage]);

    const changeRawMessage = useCallback(() => {
        setOnlyRawMessage(o => !o);
    }, []);

    useEffect(()=>{
        rpc.acceptUartLogs(true);
        return ()=>rpc.acceptUartLogs(false);
    },[rpc]);

    return (
        <Container className={'fullscreen z-index-1003'}>
            <div className="page-wrapper uart-screen">
                <div className="filters">
                    <span {...onClickHandler(hideVersion)}><input type="checkbox" checked={!versionVisible}/>{t('hide_version')}</span>
                    <input type="text" onChange={e => setFilterMessage(e.target.value)} placeholder={t('filter')}/>

                    <button {...onClickHandler(clear)}>{t('clear')}</button>
                    <button {...onClickHandler(copy)}>{t('copy')}</button>
                    <span {...onClickHandler(changeRawMessage)} className="self-right">
                        <input type="checkbox" checked={onlyRawMessage}/>
                        {t('copy_raw')}
                    </span>
                </div>
                <div className="messages">
                    {
                        filteredMessageList.map(m => {
                            return (
                                <div key={`uart_${m.id}`} className={'type-' + m.type}>
                                    <span>{m.message}</span>
                                    <span>{m.time}</span>
                                </div>
                            );
                        })
                    }
                </div>
                <div className="d-flex">
                    <input
                        onChange={e => setMessage(e.target.value)}
                        value={message}
                        type="text"
                        onKeyPress={e => onKeyPress(e)}
                    />
                    <button {...onClickHandler(send)}>{t('send')}</button>
                </div>
            </div>
        </Container>
    );
});
